// extracted by mini-css-extract-plugin
module.exports = {"root":"DocView_root__Gj6Wv","content":"DocView_content__DehzT","addSection":"DocView_addSection__H6syk"};